import { render, staticRenderFns } from "./user.vue?vue&type=template&id=7e63130d"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e63130d')) {
      api.createRecord('7e63130d', component.options)
    } else {
      api.reload('7e63130d', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=7e63130d", function () {
      api.rerender('7e63130d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/user.vue"
export default component.exports